import tw, { styled } from 'twin.macro';

const PreviewContainer = styled.div`
  width: 24rem;
  ${tw`mb-2`}

  &:not(:first-child) {
    margin-inline-start: 0.5rem;
  }

  &:not(:last-child) {
    margin-inline-end: 0.5rem;
  }

  & > div {
    ${tw`flex justify-center mx-auto`}
  }
`;

export default PreviewContainer;